import { NgModule } from '@angular/core';
import { AutopayDisableConfirmationComponent } from './autopay-disable-confirmation.component';
import { SharedModule } from '../../../../shared/shared.module';
import { UserSettingsService } from '../../../../../services/members/user-settings.service';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
    imports: [
        SharedModule,
        MatDialogModule,
    ],
    declarations: [AutopayDisableConfirmationComponent],
    exports: [AutopayDisableConfirmationComponent],
    providers: [
        UserSettingsService,
    ],
})
export class AutopayDisableConfirmationModule
{
}
